import React, { useState, useEffect } from 'react';
import './CardList.css';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import { Link } from 'react-router-dom';
import { useUser } from '../UserContext'; // Import the useUser hook
import { buildUrlWithParams } from './utils.js'

const CardList = ({ cards, loading, settings }) => {

  const cardsPerRow = settings.cardsPerRow;

  if (loading) {
    return (
      <div className={`card-list cards-per-row-${cardsPerRow}`}>
        {Array.from({ length: 40 }).map((_, index) => (
          <div className="card placeholder-card" aria-hidden="true" key={index}>
        <div className="spinner-container">
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only"></span>
          </div>
        </div>
		      {/* <div className="card-name">Loading</div> */}
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={`card-list cards-per-row-${cardsPerRow}`}>
      {cards.map((card) => (
            <Card key={card.id} card={card} />
      ))}
    </div>
  );
};

const Card = ({ card }) => {

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const img = new Image();
    img.src = `/cards/${card.cardid}.${card.format}`;
    img.onload = () => {
      setIsLoading(false);
    };
  }, [card]);

  return (
    <div className="card">
      {isLoading ? (
        <div className="spinner-container">
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only"></span>
          </div>
        </div>
      ) : (
        <>
          <Link 
            to={buildUrlWithParams({ ...Object.fromEntries(new URLSearchParams(window.location.search)), selectedCard: card.id })}
            preventScrollReset={true}
            style={{ textDecoration: 'none', zIndex: '2' }}
          ><img
            src={`/cards/${card.cardid}.${card.format}`}
            alt={card.cardname}
            className="card-image"
          /></Link>
          {card.score && card.score != '?' && card.score != '0' ? <div className="rating-star">{card.score}</div> : ''}
        </>
      )}
      <div className="card-ribbon">
      <div className="card-name">{card.author ? card.author : '-'}</div>
      </div>
    </div>
  );
};

export default CardList;
